export const init = (el) => {
    window.state = {
      visibleLogColumns: ['timestamp', 'severity', 'message'],
      container: el,
    };
    
    if (window.innerWidth > 700) {
      window.state.visibleLogColumns.push('env', 'user');
    }
    
    updateUI();

    window.state.container.addEventListener('click', (event) => {
      const row = event.target.closest('.log-row');
      const isButton = event.target.closest('button');

      // Toggle row details
      if (row && !isButton) {
        const id = row.getAttribute('data-log-id');
        toggleDetails(id);
      }

      // Toggle columns
      const colBtn = event.target.closest('.js-toggle-col');
      if (colBtn) {
        const colName = colBtn.getAttribute('data-col');
        toggleColumn(event, colName);
      }
    });
};

function toggleDetails(id) {
  const row = document.getElementById(id);
  if (row) {
    row.classList.toggle('expanded');
  }
}

function toggleColumn(event, colName) {
  event.preventDefault();
  event.stopPropagation();

  const cols = window.state.visibleLogColumns;
  const index = cols.indexOf(colName);

  if (index > -1 && cols.length > 1) {
    cols.splice(index, 1);
  } else if (index === -1) {
    cols.push(colName);
  }

  updateUI();
}

function updateUI() {
  const { visibleLogColumns, container } = window.state;
  const allColsOrder = ['timestamp', 'severity', 'message', 'env', 'user', 'trace', 'span'];
  
  // Sort visible columns based on the canonical order
  visibleLogColumns.sort((a, b) => allColsOrder.indexOf(a) - allColsOrder.indexOf(b));

  const gridWrapper = container.querySelector('#loglist-grid-wrapper');
  if (gridWrapper) {
    gridWrapper.style.gridTemplateColumns = visibleLogColumns
      .map(c => c === 'message' ? 'minmax(80px, 1fr)' : 'minmax(50px, auto)')
      .join(' ');
  }

  container.querySelectorAll('[data-name]').forEach(el => {
    const rawName = el.dataset.name;
    const isTitle = rawName.startsWith('title-');
    const name = rawName.replace('title-', '');

    if (allColsOrder.includes(name)) {
      if (isTitle) {
        el.classList.toggle('is-active', visibleLogColumns.includes(name));
      } else {
        el.classList.toggle('hidden', !visibleLogColumns.includes(name));
      }
    }
  });

  container.setAttribute('data-visible-cols', visibleLogColumns.join(','));
}

